import { useParams } from 'react-router-dom';
import Portlet from '../../../app/components/portlet/Portlet';
import PortletBody from '../../../app/components/portlet/PortletBody';
import {
  useAddThirdPartyIntegrationMutation,
  useDisconnectProviderMutation,
  useGetThirdPartyProvidersQuery,
} from '../../company/companyApiSlice';
import DynamicFormSection from '../components/DynamicFormSection';
import { StyledLabel } from '../../../assets/styledComponents/Global';
import theme from '../../../utils/themes';
import TrashIcon from '../../../app/components/svgIcons/TrashIcon';
import { toast } from 'react-toastify';
import { TPIntegrations } from '../../../utils/helper';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ThirdPartyListingContainer = () => {
  const { compId } = useParams();
  const [activeIntegration, setActiveIntegration] = useState(null);
  const [addThirdParty, { isLoading }] = useAddThirdPartyIntegrationMutation();
  const [removeProvider, { isLoading: removeLoading }] =
    useDisconnectProviderMutation();
  const {
    data: provider,
    refetch,
    isFetching,
  } = useGetThirdPartyProvidersQuery(
    {
      id: compId,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const refNow = provider?.CompProviderDetails?.find(
    (pro) => pro?.provider?.accessKey === TPIntegrations?.REFNOW,
  );

  const uCheck = provider?.CompProviderDetails?.find(
    (pro) => pro?.provider?.accessKey === TPIntegrations?.UCHECK,
  );

  // useEffect(() => {
  //   console.log("is ki");
  //   setInitialFormValues((prev) => ({
  //     ...prev,
  //     uCheck: {
  //       providerAccessKey: TPIntegrations?.UCHECK,
  //     },
  //     RefNow: {
  //       providerAccessKey: TPIntegrations?.REFNOW,
  //     },
  //   }));
  // }, [provider]);

  const addThirdIntegration = (values) => {
    const val = {
      companyId: compId,
      companyProviderDetails: [
        {
          providerAccessKey: values?.providerAccessKey,
          authKey: values?.authKey,
          authSecret: values?.authSecret,
        },
      ],
    };

    addThirdParty(val)
      .unwrap()
      .then((res) => {
        toast.success(res?.message, 'Third party integrated successfully');
        refetch();
      });
  };

  const disconnectProvider = (id) => {
    removeProvider({ compId: compId, compProviderId: id })
      .unwrap()
      .then((res) => {
        toast.success(res?.message || 'Provider Disconnected Successfully');
        refetch();
      });
  };

  const dynamicSections = [
    {
      title: 'RefNow',
      buttonLabel: refNow ? '' : 'Connect',
      buttonType: refNow ? 'text' : 'primary',
      buttonLoading: isLoading && activeIntegration === 'RefNow',
      loadingText: 'Connecting...',
      buttonIcon: refNow ? (
        removeLoading && activeIntegration === 'RefNow' ? (
          <span
            className={`spinner spinner-border spinner-border-sm me-2 ${
              !removeLoading ? 'd-none' : 'd-inline-block'
            }`}
            style={{
              transition: 'all 0.3s linear',
            }}
          />
        ) : (
          <TrashIcon
            size={20}
            onClick={(e) => {
              e.stopPropagation();
              setActiveIntegration('RefNow');

              disconnectProvider(refNow?.id);
            }}
          />
        )
      ) : undefined,
      labelText: refNow ? 'Connected' : undefined,
      onButtonClick: async (values) => {
        setActiveIntegration('RefNow');
        await addThirdIntegration(values);
      },
      fields: [
        {
          label: 'Provider Access Key',
          name: 'providerAccessKey',
          initialValue: TPIntegrations?.REFNOW,
          disabled: true,
        },
        {
          label: 'Auth Key',
          name: 'authKey',
          initialValue: refNow && refNow?.authKey,
        },
        {
          label: 'Auth Secret',
          name: 'authSecret',
          initialValue: refNow && refNow?.authSecret,
          required: true,
        },
      ],
    },
    {
      title: 'uCheck',
      buttonLabel: uCheck ? '' : 'Connect',
      buttonType: uCheck ? 'text' : 'primary',
      loadingText: 'Connecting...',
      buttonLoading: isLoading && activeIntegration === 'uCheck',
      labelText: uCheck ? 'Connected' : undefined,
      buttonIcon: uCheck ? (
        removeLoading && activeIntegration === 'uCheck' ? (
          <span
            className={`spinner spinner-border spinner-border-sm me-2 ${
              !removeLoading ? 'd-none' : 'd-inline-block'
            }`}
            style={{
              transition: 'all 0.3s linear',
            }}
          />
        ) : (
          <TrashIcon
            size={20}
            onClick={(e) => {
              e.stopPropagation();
              setActiveIntegration('uCheck');
              disconnectProvider(uCheck?.id);
            }}
          />
        )
      ) : undefined,
      onButtonClick: async (values) => {
        setActiveIntegration('uCheck');
        await addThirdIntegration(values);
      },
      fields: [
        {
          label: 'Provider Access Key',
          initialValue: TPIntegrations?.UCHECK,
          name: 'providerAccessKey',
          disabled: true,
        },
        {
          label: 'Auth Key',
          name: 'authKey',
          initialValue: uCheck && uCheck?.authKey,
        },
        {
          label: 'Auth Secret',
          name: 'authSecret',
          initialValue: uCheck && uCheck?.authSecret,
          required: true,
        },
      ],
    },
  ];

  return (
    <div>
      <Portlet>
        <div className="portlet__body-bg">
          <PortletBody>
            <>
              <div className="d-flex flex-column pt-3 pb-4">
                <StyledLabel
                  size={'20px'}
                  weight={600}
                  color={theme.headingColor}
                >
                  Third Party Applications
                </StyledLabel>
                <StyledLabel
                  size={'14px'}
                  weight={400}
                  color={theme.headingColor}
                >
                  Integrate your account with external applications to enhance
                  your workflow
                </StyledLabel>
              </div>
              {isFetching
                ? Array(2)
                    .fill(null)
                    .map((col, ind) => (
                      <div className="d-flex flex-column m-2 border rounded pt-5 ">
                        <Skeleton height={40} width={'10%'} className="ms-3" />
                        <div className="d-flex m-2  ">
                          {Array(3)
                            .fill(null)
                            .map((col, ind) => (
                              <div key={ind} className="m-2 w-50 flex-grow-1">
                                <Skeleton
                                  height={50}
                                  width={'100%'}
                                  className="me-2 mt-2 "
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                    ))
                : dynamicSections?.map((section, idx) => (
                    <DynamicFormSection
                      key={idx}
                      sectionTitle={section?.title}
                      buttonLabel={section?.buttonLabel}
                      onButtonClick={(values) => {
                        section?.onButtonClick(values);
                      }}
                      fieldsData={section?.fields}
                      buttonType={section?.buttonType}
                      buttonIcon={section?.buttonIcon}
                      labelText={section?.labelText}
                      buttonLoading={section?.buttonLoading}
                      loadingText={section?.loadingText}
                    />
                  ))}
            </>
          </PortletBody>
        </div>
      </Portlet>
    </div>
  );
};

export default ThirdPartyListingContainer;
